import { render, staticRenderFns } from "./ModalBooking.vue?vue&type=template&id=5b10b686&"
import script from "./ModalBooking.vue?vue&type=script&lang=js&"
export * from "./ModalBooking.vue?vue&type=script&lang=js&"
import style0 from "./ModalBooking.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports